<div class="d-flex flex-column full-height">
  <div class="bottombar-buttons">
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <div class="d-flex flex-row align-items-center group-info flex-auto" *ngIf="influencerGroup">
          <span>{{'group_details.action_bar.group_name' | translate:{groupName: influencerGroup.influencer_group_name} }}</span>
          <img src="assets/images/Arrow_Right.svg" width="5" height="8" class="breadcumb-seperate-arrow"/>
          <span>{{'add_influencer_manually.breadcumd' | translate}}</span>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="d-flex flex-auto align-items-center justify-content-end">
          <div class="d-flex flex-row">
            <button class="button red back-button" (click)="openConfirmationBeforeExisting()">{{'common.btn.back' | translate}}</button>
            <button class="button green save-close-influencer" (click)="addNewInfluencer()">{{'add_influencer_manually.import_btn' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottombar-content add-influencer-form">
    <form #platformSettingForm="ngForm" class="add-influencer-manually-form" (ngSubmit)="addNewInfluencer()">
      <div class="row">
        <div class="col-md-6">
          <div class="row left-box">
            <div class="col-md-12">
              <div class="influencer_info">{{'add_influencer_manually.influencer_info' | translate}}</div>
            </div>
            <div class="col-md-12">
              <div class="field-container">
                <achoo-text-field label="{{'add_influencer_manually.influencer_name' | translate}}"
                                  [(model)]="newInfluencer.domain"
                                  name="newInfluencer.domain"
                                  class="input-field">
                </achoo-text-field>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <div class="field-container">
                    <achoo-filter-box label="{{'add_influencer_manually.influencer_country' | translate}}"
                                      [options]="countryList"
                                      name="newInfluencer.country"
                                      placeholder="{{'add_influencer_manually.influencer_country_placeholder' | translate}}"
                                      [(model)]="newInfluencer.country">
                    </achoo-filter-box>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="field-container">
                    <achoo-filter-box label="{{'add_influencer_manually.influencer_lang' | translate}}"
                                      [options]="languageList"
                                      [multiple]="true"
                                      name="newInfluencer.languages"
                                      placeholder="{{'add_influencer_manually.influencer_lang_placeholder' | translate}}"
                                      [(model)]="newInfluencer.languages">
                    </achoo-filter-box>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="field-container">
                <achoo-text-field label="{{'add_influencer_manually.influencer_personal_email' | translate}}"
                                  [(model)]="newInfluencer.email"
                                  name="newInfluencer.email"
                                  class="input-field">
                </achoo-text-field>
              </div>
            </div>
            <div class="col-md-12 mt-5px">
              <label>{{'add_influencer_manually.influencer_gender' | translate}}</label>
              <div class="d-flex flex-row">
                <div class="gender-infl-option">
                  <achoo-radio-button [name]="'newInfluencer.gender'"
                                      [id]="'female'"
                                      [(model)]="newInfluencer.gender"
                                      [value]="0"
                                      [label]="'add_influencer_manually.influencer_gender_female' | translate"
                                      name="newInfluencer.gender" (modelChange)="onSelectGender($event)">
                  </achoo-radio-button>
                </div>
                <div class="gender-infl-option male-gender">
                  <achoo-radio-button [name]="'newInfluencer.gender'"
                                      [id]="'male'"
                                      [(model)]="newInfluencer.gender"
                                      [value]="1"
                                      [label]="'add_influencer_manually.influencer_gender_male' | translate"
                                      name="newInfluencer.gender" (modelChange)="onSelectGender($event)">
                  </achoo-radio-button>
                </div>
                <div class="gender-infl-option">
                  <achoo-radio-button [name]="'newInfluencer.gender'"
                                      [id]="'online_media'"
                                      [(model)]="newInfluencer.gender"
                                      [value]="2"
                                      [label]="'add_influencer_manually.influencer_gender_online_media' | translate"
                                      name="newInfluencer.gender" (modelChange)="onSelectGender($event)">
                  </achoo-radio-button>
                </div>
              </div>
              <div *ngIf="genderError" class="d-flex field-container">
                <p class="error" role="alert">
                  {{genderError.message}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row right-box">
            <div class="col-md-12">
              <div class="influencer_info">{{'add_influencer_manually.influencer_profiles' | translate}}</div>
            </div>
            <div class="col-md-12">
              <div class="row active-channel-list">
                <div class="col-md-12 channel-item" *ngFor="let channel of influencerChannels; trackBy: trackInfluencerChannel; let i = index">
                  <div class="d-flex flex-row flex-auto">
                    <span class="channel-prefix">{{getPrefixByPlatform(channel.platform_id)}}</span>
                    <div class="material-field infl-channel-field {{findChannelNameById(channel.platform_id)}}">
                      <achoo-material-input placeholder="{{'add_influencer_manually.channel_placeholder' | translate}}"
                                            name="{{channelFormName(channel.platform_id)}}"
                                            [(model)]="channel.handle">
                      </achoo-material-input>
                    </div>
                    <a class="icon-delete" (click)="deleteInfluencerProfile(channel.platform_id)"></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="field-container choose-platform" [ngClass]="{'on-top': newInfluencer.activeChannels.length >= 5}">
                <achoo-filter-box #platformList [options]="listPlatform"
                                  (closeDropDownEvent)="onSelectChannel($event)"
                                  [multiple]="true"
                                  name="newInfluencer.channels"
                                  placeholder="{{'add_influencer_manually.influencer_channel_placeholder' | translate}}"
                                  [(model)]="newInfluencer.activeChannels">
                </achoo-filter-box>
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<achoo-popup #NotificationAfterAddingNewInfluencerSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <span>{{'add_influencer_manually.notification_add_successfully' | translate}}</span>
</achoo-popup>
<achoo-popup #ConfirmationBeforeExistingNewInfluencerFragment
             cancelBtnLabel="{{'add_influencer_manually.cancel_button' | translate }}"
             acceptBtnLabel="{{'add_influencer_manually.confirm_accept_button' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="closeAddInfluencerManuallyFragment()"
             (cancelCallback)="closeConfirmationPopup()">
  <span>{{'add_influencer_manually.confirmation_message' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/add-influencer-manually/add-influencer-manually.component.html